import { createAction } from '@cobuildlab/react-simple-state';
import {
  changeCommentStatusErrorEvent,
  changeCommentStatusEvent,
  changeMultipleCommentStatusErrorEvent,
  changeMultipleCommentStatusEvent,
  changeMultipleRepliesStatusErrorEvent,
  changeMultipleRepliesStatusEvent,
  changeReplyCommentStatusErrorEvent,
  changeReplyCommentStatusEvent,
  fetchCommentErrorEvent,
  fetchCommentEvent,
  fetchCommentsErrorEvent,
  fetchCommentsEvent,
  fetchCommentUrlErrorEvent,
  fetchCommentUrlEvent,
  fetchSearchCommentsErrorEvent,
  fetchSearchCommentsEvent,
  fetchSearchRepliesErrorEvent,
  fetchSearchRepliesEvent,
} from './comment-events';
import axios from 'axios';
import { PostComment, Comment, CommentStatuses } from './comment-types';
import { BACKEND_ENDPOINT } from '../../shared/constants';

export const fetchComments = createAction(
  fetchCommentsEvent,
  fetchCommentsErrorEvent,
  async (page: number, pageSize: number) => {
    const response = await axios.get<{
      postComments: PostComment[];
      count: number;
    }>(`${BACKEND_ENDPOINT}/api/post/comments`, { params: { page, pageSize } });

    const data = response.data;

    return {
      comments: data.postComments,
      count: data.count,
    };
  },
);
export const fetchCommentURL = createAction(
  fetchCommentUrlEvent,
  fetchCommentUrlErrorEvent,
  async ( post_id: number) => {
    const response = await axios.get<{
      postComments: PostComment[];
    }>(`${BACKEND_ENDPOINT}/api/post/comment-url`, { params: { post_id } });

    const data = response.data;

    return {
      comments: data.postComments,
    };
  },
);

export const fetchComment = createAction(
  fetchCommentEvent,
  fetchCommentErrorEvent,
  async (id: string, page: number, pageSize: number) => {
    const response = await axios.get<{
      comments: Comment[];
      count: number;
    }>(`${BACKEND_ENDPOINT}/api/post/comments/${id}`, {
      params: { page, pageSize },
    });

    const data = response.data;

    return {
      comments: data.comments,
      count: data.count,
    };
  },
);

export const changeCommentStatus = createAction(
  changeCommentStatusEvent,
  changeCommentStatusErrorEvent,
  async (id: number, status?: CommentStatuses) => {
    const response = await axios.post<{
      comment: Comment;
    }>(`${BACKEND_ENDPOINT}/api/post/comment/${id}/update`, {
      status,
    });

    const data = response.data;

    return {
      comment: data.comment,
    };
  },
);

export const changeReplyCommentStatus = createAction(
  changeReplyCommentStatusEvent,
  changeReplyCommentStatusErrorEvent,
  async (id: number, status?: CommentStatuses) => {
    const response = await axios.post<{
      comment: Comment;
    }>(`${BACKEND_ENDPOINT}/api/post/reply-comment/${id}/update`, {
      status,
    });

    const data = response.data;

    return {
      comment: data.comment,
    };
  },
);

export const fetchSearchComments = createAction(
  fetchSearchCommentsEvent,
  fetchSearchCommentsErrorEvent,
  async (page: number, pageSize: number, search?: string) => {
    //if (search) {
    const response = await axios.get<{
      postComments: Comment[];
      count: number;
    }>(`${BACKEND_ENDPOINT}/api/general/comments`, {
      params: { page, pageSize, search },
    });

    const data = response.data;
    return {
      comments: data.postComments,
      count: data.count,
    };
    //}
    return {
      comments: [],
      count: 0,
    };
  },
);

export const fetchSearchReplies = createAction(
  fetchSearchRepliesEvent,
  fetchSearchRepliesErrorEvent,
  async (page: number, pageSize: number, search?: string) => {
    const response = await axios.get<{
      postComments: Comment[];
      count: number;
    }>(`${BACKEND_ENDPOINT}/api/general/replies`, {
      params: { page, pageSize, search },
    });

    const data = response.data;
    return {
      comments: data.postComments,
      count: data.count,
    };

    return {
      comments: [],
      count: 0,
    };
  },
);

export const changeMultipleCommentStatus = createAction(
  changeMultipleCommentStatusEvent,
  changeMultipleCommentStatusErrorEvent,
  async (status?: CommentStatuses, search?: string, ids?: number[]) => {
    const response = await axios.post<{
      comments: { count: number };
    }>(`${BACKEND_ENDPOINT}/api/general/comments/update`, {
      status,
      search,
      ids: ids?.join(','),
    });

    const data = response.data;

    return {
      comments: {
        count: data.comments.count,
      },
    };
  },
);
export const changeMultipleRepliesStatus = createAction(
  changeMultipleRepliesStatusEvent,
  changeMultipleRepliesStatusErrorEvent,
  async (status?: CommentStatuses, search?: string, ids?: number[]) => {
    const response = await axios.post<{
      comments: { count: number };
    }>(`${BACKEND_ENDPOINT}/api/general/replies/update`, {
      status,
      search,
      ids: ids?.join(','),
    });

    const data = response.data;

    return {
      comments: {
        count: data.comments.count,
      },
    };
  },
);
